import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  TenantRequestDto,
  TenantRequestReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import TenantRequestInline, { TenantRequestInlineProps } from "./TenantRequestInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: TenantRequestDto | TenantRequestReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<TenantRequestInlineProps>;
}

export default function TenantRequestLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.TenantRequestRead]}
      to={ROUTE_PATH.TENANT_REQUEST_VIEW(entity?.id || entityId || "")}
      content={<TenantRequestInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
